import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import AxiosClient from 'configurations/api-client';
import { authTokenSelector } from 'selectors/auth';
import { createOAuthSession } from 'utils/oauth-session';

const API_DISCOURSE_COMMUNITIES = '/discourse_communities';
const DISCOURSE_COMMUNITIES_QUERY_KEY = 'discourseCommunities';

export const useGetDiscourseCommunityListQuery = ({ enabled = true } = {}) => {
  const query = useQuery({
    queryKey: [DISCOURSE_COMMUNITIES_QUERY_KEY],
    queryFn: async ({ signal }) => {
      const response = await AxiosClient.get(API_DISCOURSE_COMMUNITIES, { signal });
      return response.data;
    },
    enabled,
    refetchOnWindowFocus: false,
    staleTime: 15 * 60 * 1000,
  });

  return query;
};

export const useConnectDiscourseCommunity = () => {
  const authToken = useSelector(authTokenSelector);

  return useCallback(
    (community) => {
      createOAuthSession(authToken);
      window.open(`https://${community.domain}/login`, '_blank');
    },
    [authToken],
  );
};
